export default __webpack_public_path__ + "static/media/icn-search-blue.102f4ccc.svg";